import { render } from "./QBEJoinDefinitionDialog.vue?vue&type=template&id=45c3ec12&ts=true"
import script from "./QBEJoinDefinitionDialog.vue?vue&type=script&lang=ts"
export * from "./QBEJoinDefinitionDialog.vue?vue&type=script&lang=ts"

import "./QBEJoinDefinitionDialog.vue?vue&type=style&index=0&id=45c3ec12&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__